import { ActionTypes } from './constants';
import { AnalyticsTypes } from '../../../middleware/google-analytics';
import { PROFILE_GA_CATEGORY } from '../../../profile/ActiveProfile/constants';
import { EVENT_INITIATORS, INTERACTION_TYPES, TARGETS } from '../../../EventTrackingConstants';

export const onOutOfNetworkModalShow = () => ({
    type: ActionTypes.SHOW_OUT_OF_NETWORK_MODAL,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category: PROFILE_GA_CATEGORY,
            action: 'show out of network modal',
            tags: ['insurance out-of-network modal'],
            data: {
                Section: TARGETS.INSURANCE_OUT_OF_NETWORK_MODAL,
                Component: TARGETS.INSURANCE_OUT_OF_NETWORK_MODAL,
                InteractionType: INTERACTION_TYPES.VIEW,
                Initiator: EVENT_INITIATORS.SYSTEM,
                Element: TARGETS.INSURANCE_OUT_OF_NETWORK_MODAL,
                EventAction: 'show out of network modal',
            },
        },
    },
});

export const clickBookAnyway = () => ({
    type: ActionTypes.CLICK_BOOK_ANYWAY,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category: PROFILE_GA_CATEGORY,
            action: 'click book anyway',
            tags: ['insurance out-of-network modal'],
            data: {
                Section: TARGETS.INSURANCE_OUT_OF_NETWORK_MODAL,
                Component: TARGETS.BOOK_ANYWAY,
                InteractionType: INTERACTION_TYPES.CLICK,
                Initiator: EVENT_INITIATORS.USER,
                Element: TARGETS.BOOK_ANYWAY,
                EventAction: 'click book anyway',
            },
        },
    },
});

export const clickChangeInsurance = () => ({
    type: ActionTypes.CLICK_CHANGE_INSURANCE,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category: PROFILE_GA_CATEGORY,
            action: 'click change insurance',
            tags: ['insurance out-of-network modal'],
            data: {
                Section: TARGETS.INSURANCE_OUT_OF_NETWORK_MODAL,
                Component: TARGETS.CHANGE_INSURANCE,
                InteractionType: INTERACTION_TYPES.CLICK,
                Initiator: EVENT_INITIATORS.USER,
                Element: TARGETS.CHANGE_INSURANCE,
                EventAction: 'click change insurance',
            },
        },
    },
});
